import React, { useState } from "react";
import ExtjsReact from "app/common/utils/ExtReact";
import COLORS from "scss/colors.module.scss";
import { Button } from "@material-ui/core";
import { useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { Widgets } from "@material-ui/icons";
import ApiClient from "utils/ApiClient";
import DPARHarvestProcessBinReport from "app/list/ToolBar/DPARHarvestProcessBinReport";
import DPARMillingSortexReport from "app/list/ToolBar/DPARMillingSortexReport";

const PackDashBoard = ({ store }) => {
  let match = useRouteMatch("/pack/:id/list/:listId");
  let showDashBoard = match?.params?.listId === "dashboard" ? true : false;
  return (
    <div
      style={{
        fontSize: 14,
        cursor: "pointer",
        display: "flex",
        marginLeft: 5,
        backgroundColor: showDashBoard ? COLORS.PRIMARY_COLOR : "rgba(0, 0, 0, 0.1)",
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        color: showDashBoard ? COLORS.SECONDARY_COLOR : "#eee",
        paddingLeft: 15,
        paddingRight: 15,
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
      onClick={() => {
        store.appStore.routerHistory.push(`/pack/${match.params?.id}/list/dashboard`);
      }}
    >
      Dashboard
    </div>
  );
};

export default PackDashBoard;

export const RenderDashBoard = ({ update }) => {
  let match = useRouteMatch("/pack/:id/list/:listId");
  let id = match?.params?.id;
  return (
    <Wrapper
      update={update}
      id={id}
    />
  );
};

function Wrapper({ update, id }) {
  const DashBoard = React.memo(
    ({ update }) => {
      return (
        <ExtjsDashBoard
          className="tl-gridpanel"
          style={{ flex: 1 }}
          id={id}
        />
      );
    },
    [update]
  );

  return <DashBoard />;
}

class ExtjsDashBoard extends ExtjsReact {
  renderExtjsCmp(props = this.props) {
    this.extjsCmp = showExtjsDashBoard(this.renderTo, this.props.id);
    window.appStore.currentViewStore = this;
  }

  componentWillReceiveProps(props) {
    this.renderExtjsCmp(props);
  }
}

async function showExtjsDashBoard(renderTo, id = null) {
  let dashBoardId = window.appStore?.packStore?.pack?.dashboard_id;

  if (!dashBoardId) {
    try {
      let pack = await ApiClient.Packs.getPack({ id: id });
      if (pack.success) {
        dashBoardId = pack?.data?.dashboard_id;
      }
    } catch (error) {
      return null;
    }
  }

  if (!dashBoardId) {
    return null;
  }

  const currentUserViewPanel = TL.list.views.ViewsFactory.get("dashboard", {
    renderTo: renderTo,
    height: "100%",
    width: "100%",
    viewConfig: {
      options: {
        dashboard_id: dashBoardId,
      },
    },
    // listeners: {
    //   viewedit: async function (viewId, a, b, c, d) {
    //     let viewResp = await ApiClient.Views.getView({view_id:viewId});
    //     const listId = viewResp.data?.list_id;
    //     viewResp = viewResp.data;
    //     // let tempviewresp = await ApiClient.Views.getView({view_id:viewId, list_id:listId});
    //     const listConfig = await ApiClient.List.getListConfig({list_id:listId});

    //     const listConfigForViewsService = {
    //       color_codes: listConfig.data.colorCodes,
    //       custom_events: [],
    //       list: listConfig.data.list,
    //       list_columns: listConfig.data.listData,
    //       list_permissions: listConfig.data.listPermissions,
    //     };
    //     let isEditMode = false;

    //     const viewPermissions = Ext.create("TL.list.permissions.Permissions", {
    //       permissions: listConfig.listPermissions,
    //     });

    //     const viewsService = Ext.create(TL.list.views.Service, {
    //       //containerId: me.id,
    //       config: listConfigForViewsService,
    //       listeners: {
    //         executereport: Ext.bind(async function (viewInfo) {
    //           this.isViewInEditMode = true;
    //           if (!isEditMode) {
    //             this.initialViewId = viewId;
    //           }
    //           if (viewInfo.type == "table") {
    //             if (!isEditMode) {
    //               this.initialViewOfEditReport = viewResp;
    //             }
    //             if (viewInfo.id > 0) {
    //               viewInfo.id = 0;
    //             }
    //             this.unSavedViewOfEditReport = viewInfo;
    //           } else {
    //             if (viewInfo.id != -1) {
    //               viewInfo.id = 0;
    //             }
    //           }
    //           await this.handleViewChange(viewInfo.id, true, viewInfo);
    //         }, this),
    //         success: Ext.bind(function (viewInfo) {
    //           // this.resetRunningReportData(false);
    //         }, this),
    //         "view-deleted": Ext.bind(function () {
    //           // this.fetchViews(false, true);
    //         }, this),
    //         "view-saved": Ext.bind(function (listId, viewId) {
    //           // this.loadView(viewId);

    //         }, this),
    //       },
    //     });

    //     viewsService.showAddView(
    //       viewResp,
    //       listConfigForViewsService,
    //       viewPermissions,
    //       Ext.bind(function (viewInfo) {
    //         // this.loadView(viewInfo.id);
    //       }, this)
    //     );
    //   },
    // },
  });

  return currentUserViewPanel;
}

export const DashBoardToolbar = ({ setUpdate = () => null }) => {
  const [isDPAROpen, setIsDPAROpen] = useState(false);
  const [isDPAR2Open, setIsDPAR2Open] = useState(false);
  const showDPAR = window.LOGGED_IN_USER?.domain === "mylapur" && window.appStore?.packStore?.id == 5;
  return (
    <>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        padding: "10px 25px",
        borderBottom: "1px solid #e0dcdc",
      }}
    >
      <div
        style={{
          fontSize: "1rem",
        }}
      >
        Dashboard
      </div>
      {/* Right-side button group */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {showDPAR && (
          <Button
            style={{
              background: "linear-gradient(135deg, #1565c0, #1976d2)",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              letterSpacing: 0.3,
              boxShadow: "0 2px 6px rgba(21,101,192,0.3)",
              whiteSpace: "nowrap",
            }}
            variant="contained"
            onClick={() => setIsDPAROpen(true)}
            startIcon={
              <span style={{ fontSize: 15, lineHeight: 1 }}>📋</span>
            }
          >
            DPAR 1 - Harvest and Process
          </Button>
        )}
        {showDPAR && (
          <Button
            style={{
              background: "linear-gradient(135deg, #1b5e20, #2e7d32)",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              letterSpacing: 0.3,
              boxShadow: "0 2px 6px rgba(27,94,32,0.3)",
              whiteSpace: "nowrap",
            }}
            variant="contained"
            onClick={() => setIsDPAR2Open(true)}
            startIcon={
              <span style={{ fontSize: 15, lineHeight: 1 }}>⚙️</span>
            }
          >
            DPAR 2 - Milling and Sorting
          </Button>
        )}
        <Button
          style={{
            marginRight: "10px",
          }}
          variant="contained"
          color="primary"
          onClick={() => {
          let addWidgetWin = Ext.create("TL.Window", {
            title: "Add Widget",
            autoScroll: true,
            closeAction: "destroy",
            modal: true,
            width: 1300,
            layout: "fit",
            height: Ext.getBody().getViewSize().height,
            minHeight: 300,
            items: [
              Ext.create("TL.dashboard.AddWidget", {
                border: false,
                dashboardId: window.appStore?.packStore?.pack?.dashboard_id,
                listeners: {
                  success: function (obj, newWidget) {
                    setUpdate();
                    addWidgetWin.close();
                    console.log(obj, newWidget);
                  },
                  close: function () {
                    addWidgetWin.close();
                  },
                  scope: this,
                },
              }),
            ],
          });
          addWidgetWin.show();
        }}
        startIcon={<Widgets style={{ color: "white" }} />}
      >
        Add Widget
      </Button>
      </div>
      {/* outer toolbar div */}
    </div>
    {showDPAR && (
      <DPARHarvestProcessBinReport
        open={isDPAROpen}
        onClose={() => setIsDPAROpen(false)}
      />
    )}
    {showDPAR && (
      <DPARMillingSortexReport
        open={isDPAR2Open}
        onClose={() => setIsDPAR2Open(false)}
      />
    )}
    </>
  );
};
